/**
 * Blaster Beads 9 años - Countdown diario de aniversario
 *
 * Desarrollo creado para campaña de mayo 2026.
 *
 * Para reutilizar en futuras campañas modificar:
 * - CAMPAIGN_TAG en Liquid donde se valida el producto: BLASTERBEADS.
 * - CAMPAIGN_START_DATE.
 * - CAMPAIGN_END_DATE.
 * - CAMPAIGN_TIMEZONE.
 * - Logo en snippets/blaster-anniversary-countdown.liquid.
 * - Textos en snippets/blaster-anniversary-countdown.liquid.
 * - Colores en assets/base.css.
 *
 * Este script NO modifica precios.
 * Solo controla la visibilidad y el timer visual.
 */

(() => {
  /**
   * MODO DE PRUEBA TEMPORAL.
   * IMPORTANTE: antes de publicar la campaña real, volver a false.
   * Con true, el bloque se muestra fuera del rango de fechas para validar Liquid/CSS/JS.
   */
  const BLASTER_ANNIV_TEST_MODE = true;

  const CAMPAIGN_START_DATE = '2026-04-30';
  const CAMPAIGN_END_DATE = '2026-05-31';
  const CAMPAIGN_TIMEZONE = 'America/Santiago';
  const SELECTOR = '[data-blaster-anniv-countdown]';
  const TIMER_SELECTOR = '[data-blaster-anniv-time]';

  const stateKey = '__blasterAnnivCountdown';

  if (window[stateKey]?.initialized) {
    window[stateKey].init();
    return;
  }

  const state = {
    initialized: true,
    intervalId: null,
    lastFoundCount: null,
    testModeLogged: false,
    init,
  };

  window[stateKey] = state;

  function getZonedParts(date) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: CAMPAIGN_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    });

    return formatter.formatToParts(date).reduce((parts, part) => {
      if (part.type !== 'literal') {
        parts[part.type] = Number(part.value);
      }

      return parts;
    }, {});
  }

  function getTimeZoneOffsetMs(date) {
    const parts = getZonedParts(date);
    const zonedAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);

    return zonedAsUtc - date.getTime();
  }

  function zonedTimeToUtc(year, month, day, hour, minute, second) {
    const localAsUtc = Date.UTC(year, month - 1, day, hour, minute, second);
    let utcDate = new Date(localAsUtc);

    for (let i = 0; i < 2; i += 1) {
      utcDate = new Date(localAsUtc - getTimeZoneOffsetMs(utcDate));
    }

    return utcDate;
  }

  function parseDate(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);

    return { year, month, day };
  }

  function compareLocalDate(parts, dateString) {
    const normalizedCurrent = parts.year * 10000 + parts.month * 100 + parts.day;
    const date = parseDate(dateString);
    const normalizedTarget = date.year * 10000 + date.month * 100 + date.day;

    return normalizedCurrent - normalizedTarget;
  }

  function isCampaignActive(now) {
    if (BLASTER_ANNIV_TEST_MODE) {
      return true;
    }

    const parts = getZonedParts(now);

    return compareLocalDate(parts, CAMPAIGN_START_DATE) >= 0 && compareLocalDate(parts, CAMPAIGN_END_DATE) <= 0;
  }

  function getDailyDeadline(now) {
    const parts = getZonedParts(now);

    return zonedTimeToUtc(parts.year, parts.month, parts.day, 23, 59, 59);
  }

  function formatRemaining(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value) => String(value).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  function updateCountdowns() {
    const countdowns = document.querySelectorAll(SELECTOR);

    if (state.lastFoundCount !== countdowns.length) {
      console.info(`[Blaster Anniversary] bloques encontrados: ${countdowns.length}`);
      state.lastFoundCount = countdowns.length;
    }

    if (BLASTER_ANNIV_TEST_MODE && !state.testModeLogged) {
      console.info('[Blaster Anniversary] TEST MODE activo');
      state.testModeLogged = true;
    }

    const now = new Date();
    const active = isCampaignActive(now);
    const deadline = getDailyDeadline(now);
    const remaining = formatRemaining(deadline.getTime() - now.getTime());

    countdowns.forEach((countdown) => {
      countdown.hidden = !active;

      if (!active) {
        return;
      }

      const timer = countdown.querySelector(TIMER_SELECTOR);

      if (timer) {
        timer.textContent = remaining;
      }
    });
  }

  function ensureInterval() {
    if (state.intervalId) {
      return;
    }

    state.intervalId = window.setInterval(updateCountdowns, 1000);
  }

  function init() {
    updateCountdowns();
    ensureInterval();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:section:select', init);
})();
